<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Role' : 'Crear Nuevo Role' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <form [formGroup]="roleForm" (ngSubmit)="onSubmit()">
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Id del Role</mat-label>
            <input matInput formControlName="id" placeholder="Ej: admin, financiero, contabilidad" class="text-lg text-white bg-blue-primary" cdkFocusInitial>
            <mat-error *ngIf="idControl?.invalid && (idControl?.dirty || idControl?.touched)">
                <span *ngIf="idControl?.errors?.['required']">El id es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Nombre del Role</mat-label>
            <input matInput formControlName="name" placeholder="Ej: Contabilidad" class="text-lg text-white bg-blue-primary">
            <mat-error  *ngIf="nameControl?.invalid && (nameControl?.dirty || nameControl?.touched)">
                <span *ngIf="nameControl?.errors?.['required']">El nombre es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Descripción</mat-label>
            <textarea matInput formControlName="description" placeholder="Descripción detallada del role" class="text-lg text-white bg-blue-primary"></textarea>
        </mat-form-field>
        <div class="mb-4">
            <h3 class="text-gray text-sm">Asignación de Permisos</h3>
            <mat-radio-group aria-label="Tipo de Acceso" formControlName="accessType">
                <mat-radio-button value="global" class="mr-6">Acceso Global</mat-radio-button>
                <mat-radio-button value="custom">Acceso Personalizado</mat-radio-button>
            </mat-radio-group>
        </div>
        <div *ngIf="accessTypeControl?.value === 'custom'" class="mb-4">
            <div class="flex items-end gap-2 mb-4">
                <mat-form-field floatLabel="always" class="flex-grow">
                    <mat-label class="text-gray text-lg">Seleccionar Grupo</mat-label>
                    <input matInput [formControl]="groupFilterControl" [matAutocomplete]="autoGroup" placeholder="Buscar y seleccionar grupo">
                    <mat-autocomplete #autoGroup="matAutocomplete" [displayWith]="displayGroupName">
                        <mat-option *ngFor="let group of filteredGroups | async" [value]="group" >{{group.name}}</mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="groupFilterControl.invalid && (groupFilterControl.dirty || groupFilterControl.touched)">
                        <span *ngIf="groupFilterControl.errors?.['notAGroupObject']">Por favor, seleccione un grupo de la lista.</span>
                    </mat-error>
                </mat-form-field>
                <button matIconButton type="button" [disabled]="!(typeof groupFilterControl.value === 'object' && groupFilterControl.value !== null)" (click)="onAddGroup()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <div *ngIf="assignedGroupsControl.length === 0" class="text-gray-500 text-center border rounded p-3">
                No se han asignado grupos de permisos a este rol.
            </div>
            <div formArrayName="assignedGroups" class="flex flex-col gap-4">
                <mat-accordion [multi]="false">
                    <mat-expansion-panel *ngFor="let groupControl of assignedGroupsControl.controls; let i = index" [formGroupName]="i" [expanded]="i === 0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ groupControl.value.name }}</mat-panel-title>
                            <button matIconButton (click)="onRemoveGroup(i); $event.stopPropagation()" aria-label="Eliminar grupo" class="mr-6">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </mat-expansion-panel-header>
                        <mat-radio-group aria-label="Tipo de Acceso" formControlName="accessType">
                            <mat-radio-button value="full" class="mr-6">Acceso Completo</mat-radio-button>
                            <mat-radio-button value="granular">Acceso Granular</mat-radio-button>
                        </mat-radio-group>
                        <div *ngIf="groupControl.get('accessType')?.value === 'granular'">
                            <mat-checkbox *ngFor="let perm of getGranularPermissionsForGroup(groupControl.value.id)" [value]="perm.id" [checked]="groupControl.get('selectedGranularPermissions')?.value.includes(perm.id)" (change)="onGranularPermissionChange(getGranularPermissionsFormArray(groupControl), perm.id, $event.checked)" class="block mb-2 text-white text-sm">
                                {{ perm.name }} ({{ perm.id }})
                            </mat-checkbox>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <mat-slide-toggle formControlName="active" class="mb-4">
            Activo
        </mat-slide-toggle>
        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>
    </form>
</mat-dialog-content>
